"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorModalFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Constants_1 = require("../../../utils/Constants");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const storm_ui_1 = require("@amzn/storm-ui");
const styled_components_1 = __importDefault(require("styled-components"));
const CancelButton = (0, styled_components_1.default)(storm_ui_1.TextButton) ``;
const RegionSelectorModalFooter = ({ toggleModal, onContinueClick, }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const continueButtonLabel = translate(Constants_1.continueTranslationLabel);
    const cancelButtonLabel = translate(Constants_1.cancelTranslationLabel);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CancelButton, { "data-testid": Constants_1.cancelButtonTestId, onClick: toggleModal, children: cancelButtonLabel }), (0, jsx_runtime_1.jsx)(storm_ui_1.Button, { "data-testid": Constants_1.continueButtonTestId, onClick: onContinueClick, variant: 'primary', children: continueButtonLabel })] }));
};
exports.RegionSelectorModalFooter = RegionSelectorModalFooter;
//# sourceMappingURL=RegionSelectorModalFooter.js.map